package com.partejar.app.feature.home.data.remote

import kotlinx.serialization.Serializable

@Serializable
data class HomeResponseDto(
    val usuario: HomeUsuarioDto,
    val alertas: List<HomeAlertaDto> = emptyList(),
    val proximasGestantes: List<HomeProximaGestanteDto> = emptyList(),
    val agendaHoje: List<HomeAgendaEventoDto> = emptyList()
)

@Serializable
data class HomeUsuarioDto(
    val id: Long,
    val nome: String
)

@Serializable
data class HomeAlertaDto(
    val tipo: String,
    val quantidade: Int,
    val nivel: String,
    val pacienteIds: List<Long> = emptyList()
)

@Serializable
data class HomeProximaGestanteDto(
    val pacienteId: Long,
    val nomeGestante: String,
    val nomeBebe: String? = null,
    val dataProvavelParto: String,
    val idadeGestacional: HomeIdadeGestacionalDto,
    val diasAteDpp: Int,
    val responsavelPrincipal: HomeResponsavelPrincipalDto? = null,
    val situacaoOperacional: HomeSituacaoOperacionalDto
)

@Serializable
data class HomeIdadeGestacionalDto(
    val semanas: Int,
    val dias: Int
)

@Serializable
data class HomeResponsavelPrincipalDto(
    val membroWorkspaceId: Long,
    val nome: String
)

@Serializable
data class HomeSituacaoOperacionalDto(
    val status: String,
    val pendencias: List<String> = emptyList()
)

@Serializable
data class HomeAgendaEventoDto(
    val id: Long,
    val tipo: String,
    val titulo: String,
    val inicioEm: String,
    val fimEm: String,
    val pacienteId: Long? = null,
    val nomeGestante: String? = null
)
